import { z } from "zod";
import { idSchema } from "@amber/contracts";
import { profileLifecycleStateSchema } from "./records.js";

export const profileOptionSchema = z.strictObject({
  id: idSchema("prf"),
  name: z.string(),
  lifecycle_state: profileLifecycleStateSchema,
});
export type ProfileOption = z.infer<typeof profileOptionSchema>;

export const profileOptionsResponseSchema = z.strictObject({ profiles: z.array(profileOptionSchema) });
export type ProfileOptionsResponse = z.infer<typeof profileOptionsResponseSchema>;

export const profileHitSchema = profileOptionSchema.extend({ alias: z.string().nullable() });
export type ProfileHit = z.infer<typeof profileHitSchema>;
